import { Component, Input, OnInit } from '@angular/core';
import { HistoryService } from 'src/app/services/history.service';

type HistorySubTab = 'salarios' | 'trayectoria' | 'vacaciones';

@Component({
    selector: 'app-history-tab',
    templateUrl: './history-tab.component.html',
    styleUrls: ['./history-tab.component.css']
})
export class HistoryTabComponent implements OnInit {
    @Input() employee: any;

    subTab: HistorySubTab = 'salarios';

    careerRows: any[] = [];
    loadingCareer = false;
    careerError = false;
    careerSearchTerm = '';

    leaveRows: any[] = [];
    loadingLeave = false;
    leaveError = false;
    leaveSearchTerm = '';

    get filteredCareerRows(): any[] {
        const term = this.careerSearchTerm.trim().toLowerCase();
        if (!term) return this.careerRows;
        return this.careerRows.filter(row =>
            (row.record_type || '').toLowerCase().includes(term) ||
            (row.status || '').toLowerCase().includes(term) ||
            (row.position || '').toLowerCase().includes(term) ||
            (row.department || '').toLowerCase().includes(term) ||
            this.formatDate(row.date).includes(term)
        );
    }

    get filteredLeaveRows(): any[] {
        const term = this.leaveSearchTerm.trim().toLowerCase();
        if (!term) return this.leaveRows;
        return this.leaveRows.filter(row =>
            (row.type || '').toLowerCase().includes(term) ||
            this.formatDate(row.start_date).includes(term)
        );
    }

    constructor(private historyService: HistoryService) { }

    ngOnInit(): void {
        this.fetchCareerHistory();
        this.fetchLeaveHistory();
    }

    setSubTab(tab: HistorySubTab): void {
        this.subTab = tab;
    }

    fetchCareerHistory(): void {
        if (!this.employee?.id) return;
        this.loadingCareer = true;
        this.careerError = false;
        this.historyService.listCareerHistory(this.employee.id).subscribe({
            next: (resp: any) => {
                this.careerRows = Array.isArray(resp) ? resp : (Array.isArray(resp?.data) ? resp.data : []);
                this.loadingCareer = false;
            },
            error: () => {
                this.careerRows = [];
                this.loadingCareer = false;
                this.careerError = true;
            }
        });
    }

    fetchLeaveHistory(): void {
        if (!this.employee?.id) return;
        this.loadingLeave = true;
        this.leaveError = false;
        this.historyService.listLeaveHistory(this.employee.id).subscribe({
            next: (resp: any) => {
                this.leaveRows = Array.isArray(resp) ? resp : (Array.isArray(resp?.data) ? resp.data : []);
                this.loadingLeave = false;
            },
            error: () => {
                this.leaveRows = [];
                this.loadingLeave = false;
                this.leaveError = true;
            }
        });
    }

    formatDate(value: any): string {
        if (!value) return '--/--/----';
        const datePart = String(value).split('T')[0].split(' ')[0];
        const [yyyy, mm, dd] = datePart.split('-');
        if (!yyyy || !mm || !dd) return '--/--/----';
        return `${dd}/${mm}/${yyyy}`;
    }
}
